export default "__VITE_ASSET__YrMkpRYV__"